import { faCalendarWeek, faClock, faUsers } from '@fortawesome/pro-solid-svg-icons'

import type { ProgramFactoid } from '@/client/services/programs/types'

const getAboutFactoids = (withIcons: boolean): ProgramFactoid[] => [
  {
    key: 'bootcamp-duration',
    text: '4 weeks',
    subtext: '2 sessions/week',
    ...(withIcons
      ? { iconProps: { size: 'md', color: 'purple.solid', faIcon: faCalendarWeek } }
      : {}),
  },
  {
    key: 'session-duration',
    text: '75 minutes',
    subtext: 'Per session',
    ...(withIcons ? { iconProps: { size: 'md', color: 'purple.solid', faIcon: faClock } } : {}),
  },
  {
    key: 'max-session-capacity',
    text: '10 learners',
    subtext: 'Max class size',
    ...(withIcons ? { iconProps: { size: 'md', color: 'purple.solid', faIcon: faUsers } } : {}),
  },
]

export const ABOUT_FACTOIDS = getAboutFactoids(false)
export const ABOUT_FACTOIDS_WITH_ICONS = getAboutFactoids(true)
